import type { SortConfig } from '@/types/project.types';
import { ArrowDown, ArrowUp } from 'lucide-react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface SortControlsProps {
  sortConfig: SortConfig;
  onSortChange: (config: SortConfig) => void;
}

export const SortControls: FC<SortControlsProps> = ({ sortConfig, onSortChange }) => {
  const { t } = useTranslation();
  const sortFields = [
    { label: t('home.sortTitle'), value: 'title' },
    { label: t('home.sortDate'), value: 'created_at' },
  ];

  return (
    <div className="flex items-center gap-4">
      <span className="text-sm text-gray-600">{t('home.sortBy')}</span>

      <Dropdown
        value={sortConfig.field}
        options={sortFields}
        onChange={(e) => onSortChange({ ...sortConfig, field: e.value })}
        className="w-32"
      />

      <Button
        icon={sortConfig.order === 'asc' ? <ArrowUp size={16} /> : <ArrowDown size={16} />}
        onClick={() =>
          onSortChange({
            ...sortConfig,
            order: sortConfig.order === 'asc' ? 'desc' : 'asc',
          })
        }
        outlined={true}
        title={sortConfig.order === 'asc' ? t('home.ascending') : t('home.descending')}
      />
    </div>
  );
};
